var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"index-section"},[_c('video',{ref:'video' + 1,staticClass:"video",attrs:{"autoplay":false,"src":_vm.data.attachment,"controls":"","poster":_vm.data.posterDataUrl,"crossorigin":"anonymous"},on:{"loadeddata":function($event){return _vm.captureFrame(1)}}}),_c('div',{staticClass:"test"},[_vm._v(" "+_vm._s(_vm.data.title)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }